import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Unicon from 'vue-unicons'
import VueScrollTo from 'vue-scrollto';

import { uniFacebookF, uniInstagram, uniArrowRight, uniTimes, uniBell, uniCheckSquare, uniArrowUp } from 'vue-unicons/src/icons'

import "./assets/styles/app.scss";

Unicon.add([uniFacebookF, uniInstagram, uniArrowRight, uniTimes, uniBell, uniCheckSquare, uniArrowUp ]);
Vue.config.productionTip = false;

Vue.use(Unicon);
Vue.use(VueScrollTo);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: 'ease-in-out',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
